module.exports = __webpack_public_path__ + "media/assets/images/Card_4-b6cde613a2c7ce21985d8f1570b77653.png";